import { getTargetDefault } from '@nohara-dxdev/feature-flags';
import {
  constructOrgTargetId,
  FEATURE_FLAGS,
  type FeatureFlagKey,
  TARGET_ORG,
} from '@nohara-dxdev/mt-common';
import { useMemo } from 'react';

import { useOrgFeatureFlags } from '../api/get-org-feature-flags-admin';

export interface OrgFlagRow {
  flagKey: FeatureFlagKey;
  orgEnabled: boolean;
}

export interface UseFeatureFlagAdminStateResult {
  flags: OrgFlagRow[];
  isLoading: boolean;
  isError: boolean;
}

export const useFeatureFlagAdminState = (
  orgId: string | null | undefined,
): UseFeatureFlagAdminStateResult => {
  const query = useOrgFeatureFlags({ orgId });

  const flags: OrgFlagRow[] = useMemo(() => {
    if (!query.data || !orgId) return [];
    const orgTargetId = constructOrgTargetId(orgId);
    return (Object.keys(FEATURE_FLAGS) as FeatureFlagKey[]).map((flagKey) => {
      const def = FEATURE_FLAGS[flagKey];
      const orgRow = query.data.flags.find(
        (s) => s.flagKey === flagKey && s.targetType === TARGET_ORG && s.targetId === orgTargetId,
      );
      const orgEnabled = orgRow?.enabled ?? getTargetDefault(def.targets, TARGET_ORG);
      return { flagKey, orgEnabled };
    });
  }, [query.data, orgId]);

  return { flags, isLoading: query.isLoading, isError: query.isError };
};
